"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Sequence = /** @class */ (function () {
    function Sequence(prefix) {
        if (prefix === void 0) { prefix = ""; }
        this._prefix = prefix;
    }
    Sequence.prototype.next = function () {
        if (this._id === undefined) {
            this._id = 0;
        }
        else {
            this._id++;
        }
        return this._prefix + this._id;
    };
    return Sequence;
}());
exports.Sequence = Sequence;
var instances = {};
var defaultInstance = new Sequence();
var getSequence = function (name) {
    if (name !== undefined) {
        var instance = instances[name];
        if (!instance) {
            instance = new Sequence(name);
            instances[name] = instance;
        }
        return instance;
    }
    return defaultInstance;
};
exports.getSequence = getSequence;
var next = function (name) {
    return getSequence(name).next();
};
exports.next = next;
